enum NotificationTypeEnum {
  Success,
  Warning,
  Danger,
}

export default NotificationTypeEnum;
